module.exports = __webpack_public_path__ + "static/media/1.86ed8598.svg";